module.exports = __webpack_public_path__ + "img/Metallbaukonstrukteur_2018.4024d6e9.jpg";